<template>
    <div class="box chart-holder">
        <h2>
            {{ t("orderReports-charts-orders_and_income_by") }}
            <span
                v-for="(set, index) in availableSets"
                v-if="groupDataBy === set"
                :key="index"
            >
                {{ $root.t("dates-" + set) }}
            </span>

            <template v-if="availableSets.length > 1">
                <button
                    class="btn btn-sm btn-info pull-right btn-chart-menu"
                    @click="showOptions = !showOptions"
                >
                    <span
                        class="far"
                        :class="{
                            'fa-cogs': !showOptions,
                            'fa-remove': showOptions,
                        }"
                    ></span>
                </button>
            </template>
        </h2>
        <template v-if="availableSets.length > 1">
            <div class="chart-options-menu" v-if="showOptions">
                <label>{{ t("orderReports-charts-group_by") }}</label>
                <ul>
                    <li
                        v-for="(set, index) in availableSets"
                        :class="{ selected: groupDataBy === set }"
                        @click="setGroupDataBy(set)"
                        :key="index"
                    >
                        {{ $root.t("dates-" + set) }}
                    </li>
                </ul>
            </div>
        </template>
        <div class="clear"></div>
        <div style="height: 218px">
            <bar-chart
                :chart-data="ordersChartData"
                :style="myStyles"
                :options="chartOptions"
                :height="218"
                ref="chart"
            />
        </div>
    </div>
</template>
<script>
import BarChart from "../../components/charts/barChart";
import { formatCurrency } from "../../helpers/currency";
export default {
    components: { BarChart },
    data: () => ({
        showOptions: false,
        groupDataBy: "day",
        myStyles: {
            height: "218px",
            width: "100%",
            position: "relative",
        },
    }),
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        setGroupDataBy(period) {
            this.groupDataBy = period;
            this.showOptions = false;
            this.$refs.chart.renderChart(
                this.ordersChartData,
                this.chartOptions,
            );
        },
    },
    mounted() {
        this.setGroupDataBy(this.availableSets[0]);
    },
    computed: {
        availableSets() {
            let sets = [];
            for (let s in this.chart) {
                sets.push(this.chart[s].groupBy);
            }
            return sets;
        },
        chart() {
            return this.$store.state.ordersReport.report.absoluteValues;
        },
        chartOptions() {
            const currency = (this.$store.state.place && this.$store.state.place.currency) || "BRL";
            const locale = (this.$store.state.place && this.$store.state.place.locale) || null;
            return {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    callbacks: {
                        label: function (tooltipItems, data) {
                            const dataset =
                                data.datasets[tooltipItems.datasetIndex];
                            if (dataset.yAxisID === "R") {
                                return formatCurrency(
                                    tooltipItems.yLabel,
                                    currency,
                                    locale,
                                );
                            }
                            return tooltipItems.yLabel;
                        },
                    },
                },
                scales: {
                    yAxes: [
                        {
                            id: "L",
                            type: "linear",
                            position: "left",
                            ticks: {
                                maxTicksLimit: 6,
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: this.t(
                                    "orderReports-chart_axes-orders",
                                ),
                            },
                        },
                        {
                            gridLines: false,
                            id: "R",
                            type: "linear",
                            position: "right",
                            ticks: {
                                maxTicksLimit: 6,
                                beginAtZero: true,
                                callback: function (value) {
                                    return formatCurrency(value, currency, locale);
                                },
                            },
                            scaleLabel: {
                                display: true,
                                labelString: this.t(
                                    "orderReports-chart_axes-income",
                                ),
                            },
                        },
                    ],
                },
            };
        },
        ordersChartData() {
            for (let s in this.chart) {
                let set = this.chart[s];
                if (set.groupBy === this.groupDataBy) {
                    return {
                        labels: set.labels,
                        datasets: [
                            {
                                label: this.t(
                                    "orderReports-chart_axes-income",
                                ),
                                borderColor: "#FDB000",
                                borderWidth: 2,
                                pointRadius: 3,
                                pointBackgroundColor: "#EEE",
                                backgroundColor: "rgba(0,0,0,0)",
                                type: "line",
                                lineTension: 0,
                                yAxisID: "R",
                                data: set.income,
                            },
                            {
                                label: this.t(
                                    "orderReports-chart_axes-orders",
                                ),
                                backgroundColor: "#A7CCC0",
                                yAxisID: "L",
                                data: set.orders,
                            },
                        ],
                    };
                }
            }
        },
    },
};
</script>
